// extracted by mini-css-extract-plugin
module.exports = {"textImageSection":"multiTextImageSectionContent-module--textImageSection--VSMZ1","fontsLoading":"multiTextImageSectionContent-module--fonts-loading--3zA_m"};